import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[cellContent]',
})
export class CellContent {
  @Input() columnName!: string;

  constructor(public templateRef: TemplateRef<any>) {}
}
